<div
  class="fade modal-lg modal"
  id="completeTutorialsFormModal"
  tabindex="-1"
  aria-labelledby="tutorialFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="tutorialFormModalLabel">
          Creación de un tutorial
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="clearAllFields()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="tutorialsForm" (ngSubmit)="onSubmit()">
          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="text"
              [ngClass]="{ 'is-invalid': name.invalid && name.touched }"
              placeholder="Título"
              formControlName="name"
            />

            <label for="">Título</label>

            <div *ngIf="name.invalid && name.touched" class="text-danger">
              Ingrese un nombre válido (minimo 3 letras).
            </div>
          </div>

          <select class="form-select" formControlName="type">
            <option [value]="null" selected>Elige el tipo archivo</option>
            <option value="SHORT_VIDEO">Video Corto</option>
            <option value="LONG_VIDEO">Video Largo</option>
            <option value="PDF">PDF</option>
          </select>

          <div *ngIf="type.invalid && type.touched" class="text-danger">
            Ingrese un tipo válido.
          </div>

          <select
            class="form-select mt-3"
            formControlName="section"
            (change)="checkExerciseSection()"
          >
            <option [value]="null" selected>
              Elige la sección del tutorial
            </option>
            <option value="EXERCISE">Ejercicios</option>
            <option value="WARMING">Calentamientos</option>
            <option value="INTRODUCTION">Introducción</option>
            <option value="OTHERS">Otros</option>
          </select>

          <select class="form-select mt-3" formControlName="allowedUserType">
            <option [value]="null" selected>Elige alcance del tutorial</option>
            <option value="USER">App de usuarios</option>
            <option value="TABLET">Tablet en Gym</option>
            <option value="USER_TABLET">Tablet y App</option>
          </select>

          <div *ngIf="section.invalid && section.touched" class="text-danger">
            Ingrese una sección valida.
          </div>

          <div class="col-6 mt-3">
            <label for="tutorialAttachment" class="btn-custom"
              >Seleccionar Archivo</label
            >
            <input
              id="tutorialAttachment"
              style="visibility: hidden"
              type="file"
              accept="video/mp4, video/mpeg, application/pdf"
              (change)="onAttachmentSelected($event)"
            />
          </div>
          <span *ngIf="videoSelected && tutorialVideo">
            Archivo seleccionado: {{ tutorialVideo.name }}</span
          >

          <button
            [disabled]="tutorialsForm.invalid"
            class="col-12 mt-2 btn-custom d-flex justify-content-center"
          >
            <span *ngIf="!loading">Crear</span>

            <div
              *ngIf="loading"
              class="spinner-border d-flex justify-content-center"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
